import { useMemo, useState, useEffect, useCallback, useRef } from "react";
import {
  Box,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Button,
  HStack,
  Tag,
  TagLabel,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Grid,
  GridItem,
  Checkbox,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  TagCloseButton,
  IconButton,
  Select,
  Input,
} from "@chakra-ui/react";
import { useColorModeValue } from "@chakra-ui/system";
import { BsShare, BsUpload } from "react-icons/bs";
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa";
import {
  SearchIcon,
  DeleteIcon,
  AddIcon,
  CloseIcon,
  ChevronDownIcon,
} from "@chakra-ui/icons";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import ReactSelect from "react-select";
import * as XLSX from "xlsx";
import Card from "common/components/card/Card";
import CountUpComponent from "common/components/countUpComponent";
import Pagination from "common/components/pagination/Pagination";
import Spinner from "common/components/spinner/Spinner";
import CustomSearchInput from "./search/search";
import AdvanceSearchUsingCustomFields from "./search/advanceSearch";
import DataNotFound from "./notFoundData";
import moment from "moment";
import ActionNavbar from "./actionBar/ActionNavbar";
import { constant } from "common/constant";
import CustomDatePicker from "./datePicker/CustomDatePicker";
import OutlinedIconBtn from "./customButtons/OutlinedIconBtn";
import { globalStyles } from "common/theme/styles";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { generateTimestampedFilename } from "common/utils/CalcFunctions";
import { recruitConstant } from "services/Recruit/constant";
import useGlobalTable from "services/Crm/utils/tableInstance";
import LocalSearch from "./search/localSearch";
import { feedbackConstants } from "common/constant";
import { useSelector } from "react-redux";
import { fetchUserData } from "common/redux/reducers/userSlice";
import { useDispatch } from "react-redux";
import { useBulkImport } from "common/hooks/useBulkImport";

const CommonCheckTable = (props) => {
  const {
    isLoading,
    title,
    isSingleSelectionOnly,
    exportTitle,
    columnData,
    size,
    dataColumn,
    searchedDataOut,
    setSearchedDataOut,
    tableData,
    state,
    allData,
    ManageGrid,
    deleteMany,
    tableCustomFields,
    access,
    action,
    setAction,
    selectedColumns,
    setSelectedColumns,
    onOpen,
    setDelete,
    isHideNavbarAction = true,
    showNavbarActionForEmployee = false,
    showInlineTitle = false,
    inlineTitle,
    selectedValues = [],
    setSelectedValues = () => { },
    setIsImport,
    checkBox,
    AdvanceSearch,
    searchDisplay,
    setSearchDisplay,
    BackButton,
    searchboxOutside,
    setGetTagValuesOutside,
    bulkImport = false,
    setSearchboxOutside,
    isIdHide,
    onLinkClick = () => { },
    onRowClick,
    disableDefaultCellNavigation = false,
    selectedRowBg = false,
    viewData,
    smallView = false,
    minColumnWidth = undefined,
    hideDatePicker = false,
    fullHeight = false,
    activeTab = false,
    kanbanViewHandle,
    listViewHandle,
    currentView,
    setCurrentPage = () => { },
    pageSize = 10,
    currentPage = 1,
    fetchData,
    metadata = {},
    setPageSize = () => { },
    handleSortChange = () => { },
    searchbox = "",
    setSearchbox = () => { },
    handleSearchChange = () => { },
    isPagination = true,
    isDynamic = false,
    statusFilter = false,
    filterStatusOptions = [],
    isSharable = false,
    onShare = () => { },
    selectedRecruiterId = [],
    shareLoading = false,
    setSelectedRecruiterId = () => { },
    showCreatedByMeFilter = false,
    handleCreatedByMe = () => { },
    isCreatedByMeActive = false,
    createdByMeLabel = "My Tasks",
    handleStatusFilterChange,
    sortColumn = null,
    sortOrder = "",
    currentStatusFilter = "",
    createByFilter = "",
    userFilter = "",
    hideSearchBar = false,
    dateFilterProps = null,
    className = "",
    customRightFilters = null,
    customLeftFilters = null,
    statusFilterAlign = "right",
    selectFilters = [],
    showClearFilters = false,
    onClearFilters = null,
    clearFiltersLabel = "Clear",
  } = props;

  const totalCount = metadata?.totalRecords ?? (Array.isArray(tableData) ? tableData.length : undefined) ?? (Array.isArray(allData) ? allData.length : undefined);
  const hasTotalCount = totalCount !== undefined && totalCount !== null;
  const displayTitle = hasTotalCount ? `${title} (${totalCount})` : title;
  const filterControlWidth = "250px";
  const normalizedStatusFilterOptions = useMemo(() => {
    const options = Array.isArray(filterStatusOptions) ? filterStatusOptions : [];

    const isAllLike = (option) => {
      const value = String(option?.value ?? "").trim().toLowerCase();
      const label = String(option?.label ?? "").trim().toLowerCase();
      return (
        value === "" ||
        value === "all" ||
        label === "all status" ||
        label === "all statuses"
      );
    };

    const nonAllOptions = options.filter((option) => !isAllLike(option));
    const seen = new Set();
    const deduped = nonAllOptions.filter((option) => {
      const key = `${String(option?.value ?? "")}::${String(option?.label ?? "")}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });

    return [{ label: "All Status", value: "" }, ...deduped];
  }, [filterStatusOptions]);

  const creatableTitles = new Set([
    recruitConstant.createJobOpenings,
    recruitConstant.createInterView,
    recruitConstant.createCandidate,
    recruitConstant.createDepartment,
    recruitConstant.createApplications,
    recruitConstant.createReferral,
    recruitConstant.panel,
    recruitConstant.offerLetter,
    recruitConstant.BackgroundVerification,
    'Review Templates',
    'Review Cycles'
  ]);

  const canShowCreate = creatableTitles.has(title) && (
    access?.create || access === true ) && title !== feedbackConstants.feedback;

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  const [loginUser, setLoginUser] = useState(null);
  const ymdToDate = useCallback((value) => {
    if (!value) return null;
    const s = String(value);
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
    if (!m) return null;
    const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    return Number.isNaN(d.getTime()) ? null : d;
  }, []);

  const dateToYmdLocal = useCallback((dateObj) => {
    if (!dateObj) return "";
    const d = new Date(dateObj);
    if (Number.isNaN(d.getTime())) return "";
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  }, []);

  const canShowCheckbox = useMemo(() => {
    const isSharableAccess = isSharable && loginUser?.roles?.some(
      (role) =>
        role.roleName === "recruiter" ||
        role.roleName === "hiringManager" ||
        role.roleName === "admin"
    );
    return access?.delete || isSharableAccess;
  }, [access, isSharable, loginUser]);

  const isEmployeeUser = useMemo(() => {
    // Use the ACTIVE role only. Many users can have multiple roles (e.g., recruiter + employee).
    // `activeRoleId` can be an object ({_id, roleName}) OR an id string; handle both.
    const directRoleName = loginUser?.activeRoleId?.roleName;
    if (directRoleName) return String(directRoleName).toLowerCase() === "employee";

    const activeRoleId = loginUser?.activeRoleId?._id || loginUser?.activeRoleId;
    const roles = Array.isArray(loginUser?.roles) ? loginUser.roles : [];
    if (activeRoleId && roles.length) {
      const found = roles.find((role) => String(role?._id || role) === String(activeRoleId));
      const name = found?.roleName || found?.role;
      if (name) return String(name).toLowerCase() === "employee";
    }

    const fallback = loginUser?.role;
    return String(fallback || "").toLowerCase() === "employee";
  }, [loginUser]);

  const prevStateRef = useRef();
  const prevAllDataRef = useRef();
  const isInitializedRef = useRef(false);

  const [displaySearchData, setDisplaySearchData] = useState(false);
  const [searchedData, setSearchedData] = useState([]);

  const columns = useMemo(() => dataColumn, [dataColumn]);
  const [tempSelectedColumns, setTempSelectedColumns] = useState(
    () => dataColumn
  );

  const colors = globalStyles.colors;

  const data = useMemo(() => {
    if (!AdvanceSearch && displaySearchData) {
      return searchedData;
    } else {
      return tableData || [];
    }
  }, [AdvanceSearch, displaySearchData, searchedData, tableData]);

  const [manageColumns, setManageColumns] = useState(false);
  const [csvColumns, setCsvColumns] = useState([]);
  const [searchValue, setSearchValue] = useState({});
  const [getTagValues, setGetTagValues] = useState(
    props.getTagValuesOutSide ? props.getTagValuesOutSide : []
  );
  const [advaceSearch, setAdvaceSearch] = useState(false);
  const [column, setColumn] = useState("");
  const [gopageValue, setGopageValue] = useState();
  const [startDate, setStartDate] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const shouldShowDiv = location.pathname.includes("crm/leads");
  const [selectedRow, setSelectedRow] = useState(null);
  const [showLoader, setShowLoader] = useState(true);
  const dispatch = useDispatch();

  const { bulkImportCandidates, isImporting } = useBulkImport();
  useEffect(() => {
    if (loginUser === null) {
      const userFromStorage = localStorage.getItem("user");
      if (userFromStorage) {
        try {
          const parsedUser = JSON.parse(userFromStorage);
          setLoginUser(parsedUser);
        } catch (error) {
          console.error("Failed to parse user from localStorage", error);
          setLoginUser(false);
        }
      } else {
        setLoginUser(false);
      }
    }
  }, [loginUser]);

  useEffect(() => {
    const timer = setTimeout(() => setShowLoader(false), 500);
    return () => clearTimeout(timer);
  }, [data.length]);

  const page = useMemo(() => {
    if (!Array.isArray(data) || data.length === 0) return [];
    const safePageSize = pageSize || 10;
    const totalPages = Math.ceil(data.length / safePageSize);
    const safePageIndex = Math.min(currentPage || 1, totalPages);
    const start = isDynamic ? 0 : (safePageIndex - 1) * safePageSize;
    const end = isDynamic ? data.length : Math.min(start + safePageSize, data.length);
    const pageData = isDynamic ? data : data.slice(start, end);
    const rowOffset = isDynamic ? ((currentPage || 1) - 1) * safePageSize : start;

    return pageData.map((item, index) => ({
      id: String(rowOffset + index),
      index: rowOffset + index,
      original: item,
      originalSubRows: [],
      subRows: [],
      depth: 0,
      values: item,
      cells: columns.map((col) => ({
        column: col,
        value:
          typeof item[col.accessor] === "object" && item[col.accessor] !== null
            ? Array.isArray(item[col.accessor])
              ? item[col.accessor]
              : item[col.accessor]?.firstName && item[col.accessor]?.lastName
                ? item[col.accessor]?.firstName + " " + item[col.accessor]?.lastName
                : item[col.accessor]
            : item[col.accessor],
      })),
    }));
  }, [data, currentPage, pageSize, columns]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
  } = useGlobalTable(columns, data);

  const handleSearch = useCallback(
    (results) => {
      AdvanceSearch ? setSearchedDataOut(results) : setSearchedData(results);
    },
    [AdvanceSearch, setSearchedDataOut]
  );

  const handleClearSelections = useCallback(() => {
    setSelectedValues([]);
  }, [setSelectedValues]);

  const { users } = useSelector((state) => state.users);

  const handleAdvanceSearch = useCallback(
    (values) => {
      setSearchValue(values);
      const searchResult = allData?.filter((item) => {
        return tableCustomFields.every((field) => {
          const fieldValue = values[field.name];
          const itemValue = item[field.name];

          if (field.type === "select") {
            return !fieldValue || itemValue === fieldValue;
          } else if (field.type === "number") {
            return (
              [null, undefined, ""].includes(fieldValue) ||
              (itemValue !== undefined &&
                itemValue.toString().includes(fieldValue.toString()))
            );
          } else if (field.type === "date") {
            const fromDate = values[`from${field.name}`];
            const toDate = values[`to${field.name}`];

            if (!fromDate && !toDate) {
              return true;
            }

            const timeItemDate = new Date(itemValue);
            const timeMomentDate = moment(timeItemDate).format("YYYY-MM-DD");

            return (
              (!fromDate || timeMomentDate >= fromDate) &&
              (!toDate || timeMomentDate <= toDate)
            );
          } else {
            return (
              !fieldValue ||
              itemValue?.toLowerCase()?.includes(fieldValue?.toLowerCase())
            );
          }
        });
      });

      const getValue = tableCustomFields.reduce((result, field) => {
        if (field.type === "date") {
          const fromDate = values[`from${field.name}`];
          const toDate = values[`to${field.name}`];

          if (fromDate || toDate) {
            result.push({
              name: [`from${field.name}`, `to${field.name}`],
              value: `From: ${fromDate} To: ${toDate}`,
            });
          }
        } else if (values[field.name]) {
          result.push({
            name: [field.name],
            value: values[field.name],
          });
        }

        return result;
      }, []);

      setGetTagValues(getValue);
      setSearchedData(searchResult);
      setDisplaySearchData(true);
      setAdvaceSearch(false);
      if (setSearchbox) {
        setSearchbox("");
      }
    },
    [allData, tableCustomFields, setSearchbox]
  );

  useEffect(() => {
    if (!isInitializedRef.current) {
      dispatch(fetchUserData());
      isInitializedRef.current = true;
    }
  }, [dispatch]);

  const handleClear = useCallback(() => {
    AdvanceSearch
      ? props?.setSearchDisplay(false)
      : setDisplaySearchData(false);
    if (searchboxOutside) {
      setSearchboxOutside("");
    } else {
      setSearchbox("");
    }
    setGetTagValues([]);
    if (props?.getTagValuesOutSide) {
      setGetTagValuesOutside([]);
    }
    setGopageValue(1);
  }, [
    AdvanceSearch,
    props?.setSearchDisplay,
    searchboxOutside,
    setSearchboxOutside,
    setSearchbox,
    setGetTagValuesOutside,
    props?.getTagValuesOutSide,
  ]);

  const handleClick = useCallback(() => {
    if (title === recruitConstant.createJobOpenings) {
      sessionStorage.removeItem("mode");
      navigate("/recruitment/job-opening-create");
    } else if (title === recruitConstant.createInterView) {
      sessionStorage.removeItem("mode");
      navigate("/recruitment/interview-create");
    } else if (title === recruitConstant.createCandidate) {
      sessionStorage.removeItem("mode");
      navigate("/recruitment/candidate-create");
    } else if (title === recruitConstant.createDepartment) {
      navigate("/organization/department-create");
    } else if (title === recruitConstant.createApplications) {
      sessionStorage.removeItem("mode");
      navigate("/recruitment/application-create");
    } else if (title === recruitConstant.createReferral) {
      sessionStorage.removeItem("mode");
      navigate("/recruitment/referral-create");
    } else if (title === recruitConstant.panel) {
      sessionStorage.removeItem("mode");
      navigate("/recruitment/panel-create");
    } else if (title === feedbackConstants.feedback) {
      sessionStorage.removeItem("mode");
      navigate("/recruitment/feedback-create");
    }
    else if (title === recruitConstant.offerLetter) {
      sessionStorage.removeItem("mode");
      navigate("/recruitment/offerLetterCreate");
    }
    else {
      onOpen();
    }
  }, [title, navigate, onOpen]);

  const findStatus = useCallback(() => {
    const searchResult = allData?.filter(
      (item) =>
        !state ||
        (item?.status &&
          item?.status?.toLowerCase().includes(state?.toLowerCase()))
    );
    let getValue = [state || undefined].filter((value) => value);
    setGetTagValues(getValue);
    AdvanceSearch
      ? setSearchedDataOut && setSearchedDataOut(searchResult)
      : setSearchedData && setSearchedData(searchResult);
    AdvanceSearch
      ? setSearchDisplay && setSearchDisplay(true)
      : setDisplaySearchData && setDisplaySearchData(searchResult);
    setDisplaySearchData(true);
    setAdvaceSearch(false);
  }, [
    allData,
    state,
    AdvanceSearch,
    setSearchedDataOut,
    setSearchedData,
    setSearchDisplay,
  ]);

  useEffect(() => {
    if (state !== prevStateRef.current || allData !== prevAllDataRef.current) {
      if (state) {
        findStatus();
      }
      prevStateRef.current = state;
      prevAllDataRef.current = allData;
    }
  }, [state, allData, findStatus]);

  let isColumnSelected;
  const toggleColumnVisibility = useCallback(
    (columnKey) => {
      setColumn(columnKey);
      isColumnSelected = tempSelectedColumns?.some(
        (column) => column?.accessor === columnKey
      );
      if (isColumnSelected) {
        const updatedColumns = tempSelectedColumns?.filter(
          (column) => column?.accessor !== columnKey
        );
        setTempSelectedColumns(updatedColumns);
      } else {
        const columnToAdd = columnData?.find(
          (column) => column?.accessor === columnKey
        );
        setTempSelectedColumns([...tempSelectedColumns, columnToAdd]);
      }
    },
    [tempSelectedColumns, columnData]
  );

  const handleCheckboxChange = useCallback(
    (event, value) => {
      if (event.target.checked) {
        setSelectedValues &&
          setSelectedValues((prevSelectedValues) => [
            ...(isSingleSelectionOnly ? [] : prevSelectedValues),
            value,
          ]);
      } else {
        setSelectedValues &&
          setSelectedValues((prevSelectedValues) =>
            prevSelectedValues.filter(
              (selectedValue) => selectedValue !== value
            )
          );
      }
    },
    [setSelectedValues, isSingleSelectionOnly]
  );

  const handleColumnClear = useCallback(() => {
    isColumnSelected = selectedColumns?.some(
      (selectedColumn) => selectedColumn?.accessor === column?.accessor
    );
    setTempSelectedColumns(columnData);
    setManageColumns(!manageColumns ? !manageColumns : false);
  }, [selectedColumns, column, columnData, manageColumns]);

  const convertJsonToCsvOrExcel = useCallback(
    (jsonArray, csvColumns, fileName, extension) => {
      const csvHeader = csvColumns?.map((col) => col?.Header);

      const csvContent = [
        csvHeader,
        ...jsonArray?.map((row) =>
          csvColumns?.map((col) => {
            const value = row[col?.accessor];
           if (typeof value === "object" && value !== null) {
              if (value.firstName && value.lastName) {
                return `${value.firstName} ${value.lastName}`;
              }
              if (value.name) {
                return value.name;
              }
              return "";
            }
            if (col?.type === "date" && value) {
              return moment(value).format("YYYY-MM-DD");
            }
            return value || "-";
          })
        ),
      ];

      const ws = XLSX.utils.aoa_to_sheet(csvContent);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      const updatedFilename = generateTimestampedFilename(fileName, extension);

      XLSX.writeFile(wb, updatedFilename);
      setSelectedValues([]);
    },
    [setSelectedValues]
  );

  const downloadCsvOrExcel = useCallback(
    async (extension, selectedIds) => {
      try {
        if (selectedIds && selectedIds?.length > 0) {
          const selectedRecordsWithSpecificFileds = tableData
            ?.filter((rec) => selectedIds.includes(rec._id))
            ?.map((rec) => {
              const selectedFieldsData = {};
              csvColumns?.forEach((property) => {
                selectedFieldsData[property.accessor] = rec[property.accessor];
              });
              return selectedFieldsData;
            });
          convertJsonToCsvOrExcel(
            selectedRecordsWithSpecificFileds,
            csvColumns,
            exportTitle ? exportTitle : title || "data",
            extension
          );
        } else {
          const AllRecordsWithSpecificFileds = tableData?.map((rec) => {
            const selectedFieldsData = {};
            csvColumns?.forEach((property) => {
              selectedFieldsData[property?.accessor] = rec[property?.accessor];
            });
            return selectedFieldsData;
          });
          convertJsonToCsvOrExcel(
            AllRecordsWithSpecificFileds,
            csvColumns,
            exportTitle ? exportTitle : title || "data",
            extension
          );
        }
      } catch (e) {
        console.error(e);
      }
    },
    [tableData, csvColumns, exportTitle, title, convertJsonToCsvOrExcel]
  );

  const handleExportLeads = useCallback(
    (extension) => {
      downloadCsvOrExcel(extension, selectedValues)
    },
    [selectedValues, downloadCsvOrExcel]
  );

  const handleRemove = useCallback(
    (name) => {
      const activeNameKeys = Array.isArray(name?.name)
        ? name.name
        : name?.name
          ? [name.name]
          : typeof name === "string"
            ? [name]
            : [];

      const filter = (props.getTagValuesOutSide || [])
        .concat(getTagValues || [])
        .filter((item) => {
          const itemNameKeys = Array.isArray(item?.name)
            ? item.name
            : item?.name
              ? [item.name]
              : typeof item === "string"
                ? [item]
                : [];

          if (activeNameKeys.length === 0) {
            return item !== name;
          }

          return activeNameKeys.toString() !== itemNameKeys.toString();
        });
      let updatedSearchValue = { ...searchValue };
      for (let key in updatedSearchValue) {
        if (updatedSearchValue.hasOwnProperty(key)) {
          if (activeNameKeys.includes(key)) {
            delete updatedSearchValue[key];
          }
          if (updatedSearchValue[key] === "") {
            delete updatedSearchValue[key];
          }
        }
      }

      handleAdvanceSearch(updatedSearchValue);
      setGetTagValues(filter);
      if (filter?.length === 0) {
        handleClear();
      }
    },
    [
      props.getTagValuesOutSide,
      getTagValues,
      searchValue,
      handleAdvanceSearch,
      handleClear,
    ]
  );

  const handleNavigate = useCallback(
    (cell) => {
      const original = cell?.row?.original;
      const header = cell?.column?.Header;

      if (header === "Rule Name" && original?._id) {
        navigate(`/crm/workflow-rules/create`, {
          state: {
            id: original._id,
            isEdit: true,
            workflowData: original,
          },
        });
        return;
      }

      const targetId = original?.conversationId || original?._id || original?.id;

      if (targetId && typeof onLinkClick === "function") {
        if (title === "Offer Letters") {
          onLinkClick(original)
          return
        }
        const url = onLinkClick(targetId);
        if (url) {
          sessionStorage.setItem("isFromNavigation", "true");
          const state = {};
          if (viewData) state.module = viewData;
          navigate(url, { state });
        }
      }
    },
    [navigate, onLinkClick, viewData]
  );

  useEffect(() => {
    if (!isInitializedRef.current) {
      AdvanceSearch
        ? setSearchedDataOut && setSearchedDataOut(data)
        : setSearchedData && setSearchedData(data);
    }
  }, [data, AdvanceSearch, setSearchedDataOut]);

  useEffect(() => {
    if (JSON.stringify(tempSelectedColumns) !== JSON.stringify(dataColumn)) {
      setTempSelectedColumns(dataColumn);
    }
  }, [dataColumn]);

  useEffect(() => {
    const columnsToUse = selectedColumns || dataColumn;
    if (columnsToUse) {
        let tempCsvColumns = columnsToUse
          ?.filter(
            (col) => col?.Header !== "#" && col?.Header !== constant.action
          )
          ?.map((field) => ({
          Header: field?.headerLabel || field?.Header,
          accessor: field?.accessor,
        }));
      setCsvColumns([...tempCsvColumns]);
    }
  }, [selectedColumns, dataColumn]);

  const handleListView = useCallback(() => {
    console.log("handlelistView Clicked");
  }, []);

  const handleTableView = useCallback(() => {
    console.log("handleTableView Clicked");
  }, []);

  const tabActions = useMemo(
    () => ({
      list: handleListView,
      table: handleTableView,
    }),
    [handleListView, handleTableView]
  );

  const handleFilterSelect = useCallback((selectedOption) => {
    console.log("filterSelected", selectedOption);
  }, []);

  const handleActionSelect = useCallback((option) => {
    console.log("Selected Action Option:", option);
  }, []);

  const filterSelectOptions = useMemo(
    () =>
      constant.filterSelectList.map((item) => ({
        ...item,
        label: item.label.replace("title", title),
      })),
    [title]
  );

  const actionSelectOptions = useMemo(
    () =>
      constant.actionSelectList
        .filter(item => item.value !== 'mass_delete' || access?.delete)
        .map((item) => ({
          ...item,
          label: item.label.replace("title", title),
        })),
    [title, access?.delete]
  );

  const allSelectOptions = useMemo(
    () =>
      constant.allSelectOptions.map((item) => ({
        ...item,
        label: item.label.replace("title", title),
      })),
    [title]
  );

  useEffect(() => {
    const savedPaginationState = localStorage.getItem("paginationState");
    if (savedPaginationState) {
      const {
        pageName: savedPageName,
        currentPage: savedPage,
        pageSize: savedSize,
      } = JSON.parse(savedPaginationState);

      if (savedPageName === title) {
        if (savedPage !== currentPage) {
          setCurrentPage(savedPage || currentPage);
        }
        if (savedSize !== pageSize) {
          setPageSize(savedSize || pageSize);
        }
      } else {
        localStorage.removeItem("paginationState");
        if (currentPage !== 1) {
          setCurrentPage(1);
        }
        if (pageSize !== 10) {
          setPageSize(10);
        }
      }
    } else {
      const paginationState = {
        pageName: title,
        currentPage,
        pageSize,
      };
      localStorage.setItem("paginationState", JSON.stringify(paginationState));
    }
  }, [title]);

  const handlePaginationChange = useCallback(
    (newPage) => {
      const totalPages = metadata?.totalPages || 1;
      if (newPage > totalPages) {
        console.warn(
          `Requested page ${newPage} exceeds total pages ${totalPages}.`
        );
        return;
      }

      if (newPage !== currentPage) {
        setCurrentPage(newPage);

        const paginationState = {
          pageName: title,
          currentPage: newPage,
          pageSize,
        };
        localStorage.setItem(
          "paginationState",
          JSON.stringify(paginationState)
        );

        // Only call fetchData if isDynamic is true (server-side pagination)
        if (isPagination && isDynamic && fetchData) {
          const searchTerm = searchboxOutside || searchbox || "";
          const statusFilter = currentStatusFilter || "";
          const createBy = createByFilter || "";
          const selectedUserFilter = userFilter || "";

          if (statusFilter || createBy || searchTerm || sortColumn || selectedUserFilter) {
            fetchData(
              newPage,
              pageSize,
              sortColumn,
              sortOrder,
              searchTerm,
              false,
              statusFilter,
              createBy,
              selectedUserFilter
            );
          } else if (fetchData.length > 2) {
            fetchData(
              newPage,
              pageSize,
              sortColumn,
              sortOrder,
              searchTerm,
              false,
              statusFilter,
              createBy,
              selectedUserFilter
            );
          } else {
            fetchData(newPage, pageSize);
          }
        }
        // For client-side pagination (isDynamic=false), no fetchData call needed
      }
    },
    [
      currentPage,
      metadata?.totalPages,
      setCurrentPage,
      title,
      pageSize,
      isPagination,
      isDynamic,
      fetchData,
      searchbox,
      searchboxOutside,
      sortColumn,
      sortOrder,
      currentStatusFilter,
      createByFilter,
      userFilter,
    ]
  );

  const handleStatusFilterChangeLocal = useCallback(
    (e) => {
      const selectedStatus = e.target.value;

      if (handleStatusFilterChange) {
        handleStatusFilterChange(selectedStatus);
      } else {
        if (isPagination) {
          if (isDynamic) {
            fetchData(
              viewData?._id,
              1,
              pageSize,
              null,
              null,
              null,
              selectedStatus
            );
          } else {
            fetchData(1, pageSize, null, null, null, false, selectedStatus);
          }
        }
      }
    },
    [
      handleStatusFilterChange,
      isPagination,
      isDynamic,
      fetchData,
      viewData?._id,
      pageSize,
    ]
  );

  const handleShare = useCallback(() => {
    if (onShare) {
      onShare(selectedRecruiterId);
    }
  }, [onShare, selectedRecruiterId]);

  const employeeModuleHeading = inlineTitle || title;
  const employeeNavbarTitleModules = [
    "Self Reviews",
    "Peer Reviews",
    "Team Reviews",
    recruitConstant.createJobOpenings,
    recruitConstant.createApplications,
    recruitConstant.createInterView,
    feedbackConstants.feedback,
  ];
  const shouldShowEmployeeActionNavbar =
    isEmployeeUser &&
    isHideNavbarAction &&
    !showNavbarActionForEmployee &&
    employeeNavbarTitleModules.includes(title);
  const shouldShowEmployeeModuleHeading =
    isEmployeeUser &&
    isHideNavbarAction &&
    !shouldShowEmployeeActionNavbar &&
    title !== recruitConstant.createReferral &&
    !showNavbarActionForEmployee;

  return (
    <>
      {shouldShowEmployeeModuleHeading && employeeModuleHeading && (
        <Box className="employee-page-heading-row">
          <Box className="employee-page-heading-text">
            {employeeModuleHeading}
          </Box>
        </Box>
      )}
      {isHideNavbarAction &&
        (!isEmployeeUser ||
          shouldShowEmployeeActionNavbar ||
          title === recruitConstant.createReferral ||
          showNavbarActionForEmployee) && (
        <ActionNavbar
          title={displayTitle}
          showInlineTitle={showInlineTitle}
          inlineTitle={inlineTitle || displayTitle}
          onCreateClickHandler={handleClick}
          isCreateBtnVisible={
            shouldShowEmployeeActionNavbar
              ? false
              : canShowCreate
          }
          showActionDropdown={
            shouldShowEmployeeActionNavbar
              ? false
              : [
                  recruitConstant.createJobOpenings,
                  recruitConstant.createCandidate,
                  recruitConstant.createApplications,
                ].includes(title) && !(isEmployeeUser && title === recruitConstant.createJobOpenings)
          }
          selectedValues={selectedValues}
          handleExportLeads={handleExportLeads}
          setManageColumns={setManageColumns}
          setIsImport={setIsImport}
          ManageGrid={ManageGrid}
          filterSelectOption={filterSelectOptions}
          onFilterSelect={handleFilterSelect}
          actionOptions={actionSelectOptions}
          handleActionSelect={handleActionSelect}
          activeTab={activeTab}
          listViewHandle={listViewHandle}
          kanbanViewHandle={kanbanViewHandle}
          currentView={currentView}
        />
      )}
      <Card
        direction="column"
        w="100%"
        overflowX={{ sm: "scroll", lg: "hidden" }}
        className={`lead-table ${shouldShowEmployeeModuleHeading ? "employee-no-navbar-gap" : ""} ${fullHeight ? "fullHeight" : ""} ${className || ""}`}
      >
        <Grid
          templateColumns={{ base: "1fr", lg: "minmax(0, 1fr) auto" }}
          gap={2}
          className="lead-table-header"
        >
          <GridItem
            display={"flex"}
            alignItems={"center"}
            justifyContent="flex-start"
            minW={0}
          >
            {!hideSearchBar && (
              <Flex w={"auto"} alignItems={"center"} flexWrap={"wrap"} gap={2}>
                {isPagination ? (
                  <CustomSearchInput
                    className="search-input"
                    setSearchbox={
                      setSearchboxOutside ? setSearchboxOutside : setSearchbox
                    }
                    setDisplaySearchData={
                      setSearchboxOutside
                        ? props.setSearchDisplay
                        : setDisplaySearchData
                    }
                    searchbox={
                      searchboxOutside ? searchboxOutside : searchbox || ""
                    }
                    allData={allData}
                    dataColumn={columns}
                    onSearch={handleSearchChange}
                    setGetTagValues={
                      props.setGetTagValuesOutside
                        ? props.setGetTagValuesOutside
                        : setGetTagValues
                    }
                    setGopageValue={setGopageValue}
                    handleSearchChange={handleSearchChange}
                    setIsLoading={props.setIsLoading}
                  />
                ) : (
                  <LocalSearch
                    className="search-input"
                    setSearchbox={
                      setSearchboxOutside ? setSearchboxOutside : setSearchbox
                    }
                    setDisplaySearchData={
                      setSearchboxOutside
                        ? props.setSearchDisplay
                        : setDisplaySearchData
                    }
                    searchbox={
                      searchboxOutside ? searchboxOutside : searchbox || ""
                    }
                    allData={allData}
                    dataColumn={columns}
                    onSearch={handleSearch}
                    setGetTagValues={
                      props.setGetTagValuesOutside
                        ? props.setGetTagValuesOutside
                        : setGetTagValues
                    }
                    setGopageValue={setGopageValue}
                    source={title}
                    isPagination={isPagination}
                  />
                )}
                {statusFilterAlign === "left" &&
                  statusFilter &&
                  normalizedStatusFilterOptions &&
                  normalizedStatusFilterOptions.length > 0 && (
                    <Select
                      className="statusFilter"
                      size="sm"
                      width={filterControlWidth}
                      minW={filterControlWidth}
                      maxW={filterControlWidth}
                      flexShrink={0}
                      value={currentStatusFilter || ""}
                      onChange={handleStatusFilterChangeLocal}
                    >
                      {normalizedStatusFilterOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Select>
                  )}
                {statusFilterAlign === "left" ? customLeftFilters : null}
                {Array.isArray(selectFilters) && selectFilters.length > 0
                  ? selectFilters.map((filter) => {
                      const key = filter?.key || filter?.placeholder || String(Math.random());
                      if (typeof filter?.render === "function") {
                        return (
                          <Box key={key} flexShrink={0}>
                            {filter.render()}
                          </Box>
                        );
                      }

                      return (
                        <Select
                          key={key}
                          size={filter?.size || "sm"}
                          maxW={filter?.maxW || "220px"}
                          flexShrink={0}
                          value={filter?.value ?? ""}
                          onChange={(e) => filter?.onChange && filter.onChange(e.target.value, e)}
                          placeholder={filter?.placeholder}
                          isDisabled={!!filter?.isDisabled}
                        >
                          {(filter?.options || []).map((option) => (
                            <option
                              key={`${filter?.key || "filter"}-${option?.value ?? option?.label}`}
                              value={option?.value ?? ""}
                            >
                              {option?.label ?? option?.value}
                            </option>
                          ))}
                        </Select>
                      );
                    })
                  : null}
                {showClearFilters && typeof onClearFilters === "function" ? (
                  <Button size="sm" variant="outline" onClick={onClearFilters}>
                    {clearFiltersLabel}
                  </Button>
                ) : null}
              </Flex>
            )}
            {selectedValues?.length > 0 && access?.delete && !deleteMany && (
              <Box className="deleteIcon" onClick={() => setDelete(true)}>
                <div className="deleted-count">
                  <span>{selectedValues?.length ?? 0}</span>
                </div>
                <DeleteIcon
                  className=""
                  cursor={"pointer"}
                  color={colors.red[600]}
                />
              </Box>
            )}

            {selectedValues?.length > 0 &&
              isSharable &&
              loginUser?.roles?.some(
                (role) =>
                  role.roleName === "recruiter" ||
                  role.roleName === "hiringManager" ||
                  role.roleName === "admin"
              ) && (
                <Flex gap={1} ml={6}>

                  {/* Share with Recruiters - for interviews/candidates */}
                  {!onShare && (
                    <>
                      <Box>
                        <ReactSelect
                          isMulti
                          value={
                            users
                              ?.filter(
                                (user) =>
                                  user._id !== loginUser?._id &&
                                  user.roles?.some(
                                    (role) => role.roleName === "recruiter"
                                  )
                              )
                              .map((user) => ({
                                value: user._id,
                                label: `${user.firstName} ${user.lastName}`,
                              }))
                              .filter((option) =>
                                selectedRecruiterId?.includes(option.value)
                              ) || []
                          }
                          onChange={(selectedOptions) => {
                            const selectedIds = selectedOptions
                              ? selectedOptions.map((option) => option.value)
                              : [];
                            setSelectedRecruiterId(selectedIds);
                          }}
                          options={users
                            ?.filter(
                              (user) =>
                                user._id !== loginUser?._id &&
                                user.roles?.some(
                                  (role) => role.roleName === "recruiter"
                                )
                            )
                            .map((user) => ({
                              value: user._id,
                              label: `${user.firstName} ${user.lastName}`,
                            }))}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          className="basic-single-select tableReactSelect reactSelect"
                          classNamePrefix="select"
                          placeholder="Share with Recruiters"
                          isClearable
                          isSearchable
                        />
                      </Box>
                      {selectedRecruiterId &&
                        selectedRecruiterId.length > 0 && (
                          <>
                            <Box
                              className="deleteIcon"
                              onClick={handleShare}
                              style={{
                                opacity: shareLoading ? 0.6 : 1,
                                pointerEvents: shareLoading ? "none" : "auto",
                              }}
                            >
                              <div className="share-count">
                                <span>{selectedValues?.length ?? 0}</span>
                              </div>
                              <BsShare
                                strokeWidth={0.5}
                                className=""
                                cursor={"pointer"}
                                color={colors.blue[500]}
                              />
                            </Box>
                          </>
                        )}
                    </>
                  )}
                </Flex>
              )}
          </GridItem>

          <GridItem
            display={"flex"}
            flexWrap={"wrap"}
            gap={4}
            rowGap={2}
            justifyContent={"end"}
            alignItems={"center"}
          >
            {false && ((bulkImport && access?.create) || showCreatedByMeFilter) && (
              <Flex
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                justifyContent="flex-end"
                flexShrink={0}
              >
                {bulkImport && access?.create && (
                  <Button
                    variant="brand"
                    className="navCreateBtn"
                    onClick={onOpen}
                    isLoading={isImporting}
                    size="sm"
                  >
                    {constant.bulkImport}
                  </Button>
                )}
                {showCreatedByMeFilter && (
                  <Button
                    variant={isCreatedByMeActive ? "solid" : "brand"}
                    colorScheme={isCreatedByMeActive ? "green" : "brand"}
                    className="statusFilter"
                    borderRadius="None"
                    size="sm"
                    maxW="200px"  
                    onClick={handleCreatedByMe}
                  >
                    {/* {isCreatedByMeActive ? `✓ ${createdByMeLabel}` : createdByMeLabel} */}
                  </Button>
                )}
              </Flex>
            )}
            {statusFilterAlign !== "left" &&
              statusFilter &&
              normalizedStatusFilterOptions &&
              normalizedStatusFilterOptions.length > 0 && (
                <Select
                  className="statusFilter"
                  size="sm"
                  width={filterControlWidth}
                  minW={filterControlWidth}
                  maxW={filterControlWidth}
                  ml={statusFilterAlign !== "left" ? "auto" : undefined}
                  flexShrink={0}
                  value={currentStatusFilter || ""}
                  onChange={handleStatusFilterChangeLocal}
                >
                  {normalizedStatusFilterOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Select>
              )}

            {customRightFilters}
            {dateFilterProps && (
              <Flex gap={2} alignItems="center">
                <Select
                  size="sm"
                  width={filterControlWidth}
                  minW={filterControlWidth}
                  maxW={filterControlWidth}
                  flexShrink={0}
                  placeholder="Filter by Date"
                  value={dateFilterProps.dateFilter || ""}
                  onChange={(e) => {
                    const selectedFilter = e.target.value;
                    if (dateFilterProps.onDateFilterChange) {
                      dateFilterProps.onDateFilterChange(selectedFilter);
                    }
                  }}
                >
                  <option value="today">Today</option>
                  <option value="thisWeek">This Week</option>
                  <option value="thisMonth">This Month</option>
                  <option value="thisYear">This Year</option>
                  <option value="custom">Custom</option>
                </Select>

                {dateFilterProps.dateFilter === "custom" && (
                  <>
                    <Box width="170px">
                      <CustomDatePicker
                        startDate={ymdToDate(dateFilterProps.customStartDate)}
                        setStartDate={(date) => {
                          if (!dateFilterProps.onCustomDateChange) return;
                          const nextStart = dateToYmdLocal(date);
                          const currentEnd = String(dateFilterProps.customEndDate || "");
                          if (nextStart && currentEnd && nextStart > currentEnd) {
                            dateFilterProps.onCustomDateChange(currentEnd, nextStart);
                            return;
                          }
                          dateFilterProps.onCustomDateChange(nextStart, currentEnd);
                        }}
                        placeholder="From"
                        maxDate={ymdToDate(dateFilterProps.customEndDate) || undefined}
                      />
                    </Box>
                    <Box width="170px">
                      <CustomDatePicker
                        startDate={ymdToDate(dateFilterProps.customEndDate)}
                        setStartDate={(date) => {
                          if (!dateFilterProps.onCustomDateChange) return;
                          const nextEnd = dateToYmdLocal(date);
                          const currentStart = String(dateFilterProps.customStartDate || "");
                          if (nextEnd && currentStart && nextEnd < currentStart) {
                            dateFilterProps.onCustomDateChange(nextEnd, currentStart);
                            return;
                          }
                          dateFilterProps.onCustomDateChange(currentStart, nextEnd);
                        }}
                        placeholder="To"
                        minDate={ymdToDate(dateFilterProps.customStartDate) || undefined}
                      />
                    </Box>
                  </>
                )}
                {/* Show Clear button if ANY filter is active */}
                {(dateFilterProps.dateFilter ||
                  dateFilterProps.selectedDate ||
                  dateFilterProps.hasActiveFilters) && (
                    <Button
                      size="sm"
                      variant="ghost"
                      onClick={dateFilterProps.onClearDate}
                    >
                      Clear
                    </Button>
                  )}
              </Flex>
            )}
            {((bulkImport && access?.create) || showCreatedByMeFilter) && (
              <Flex
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                justifyContent="flex-end"
                flexShrink={0}
                ml="auto"
              >
                {showCreatedByMeFilter && (
                  <Button
                    variant={isCreatedByMeActive ? "solid" : "brand"}
                    colorScheme={isCreatedByMeActive ? "green" : "brand"}
                    className="statusFilter"
                    size="sm"
                    maxW="200px"
                    onClick={handleCreatedByMe}
                  >
                    {isCreatedByMeActive ? `✓ ${createdByMeLabel}` : createdByMeLabel}
                  </Button>
                )}
                {bulkImport && access?.create && (
                  <Button
                    variant="brand"
                    className="navCreateBtn"
                    onClick={onOpen}
                    isLoading={isImporting}
                    size="sm"
                  >
                    {constant.bulkImport}
                  </Button>
                )}
              </Flex>
            )}
            {false && showCreatedByMeFilter && (
              <Button
                variant={isCreatedByMeActive ? "solid" : "brand"}
                colorScheme={isCreatedByMeActive ? "green" : "brand"}
                className="statusFilter"
                size="sm"
                maxW="200px"
                onClick={handleCreatedByMe}
              >
                {isCreatedByMeActive ? `✓ ${createdByMeLabel}` : createdByMeLabel}
              </Button>
            )}
          </GridItem>
          <HStack spacing={4} mb={2}>
            {(props.getTagValuesOutSide || [])
              .concat(getTagValues || [])
              .map((item, i) => (
                <Tag
                  size={"md"}
                  p={2}
                  key={item?.value || item?.name?.toString?.() || String(item) || i}
                  borderRadius="full"
                  variant="solid"
                  colorScheme="gray"
                >
                  <TagLabel>{item?.value || String(item)}</TagLabel>
                  <TagCloseButton onClick={() => handleRemove(item)} />
                </Tag>
              ))}
          </HStack>
        </Grid>

        <div className="bodyPaginationContainer">
          <Box
            overflowY={"auto"}
            className={
              size ? `small-table-fix-container` : `table-fix-container`
            }
          >
            <Table
              {...getTableProps()}
              variant="simple"
              color="gray.500"
              mb="24px"
              className="lead-table-main"
            >
              <Thead zIndex={1}>
                {headerGroups?.map((headerGroup, index) => (
                  <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                    {headerGroup.headers
                      .filter((item) =>
                        isIdHide
                          ? item.Header !== "#" &&
                          item.Header !== "Delete Id" &&
                          item.Header !== "Action"
                          : true
                      )
                      .map((column, index) => {
                        const handleSort = () => {
                          handleSortChange(column.id);
                        };

                        return (
                          <Th
                            {...column.getHeaderProps(
                              column.isSortable !== false &&
                              column.getSortByToggleProps()
                            )}
                            pe="10px"
                            key={index}
                            borderColor={borderColor}
                            onClick={handleSort}
                            className={`${column?.Header === "Action" 
                              }`}
                          >
                            <Flex
                              align="center"
                              justifyContent={
                                column.center ? "center" : "start"
                              }
                              fontSize={{ sm: "14px", lg: "16px" }}
                              color="secondaryGray.900"
                            >
                              <span
                                className={`${column?.Header === "Action"
                                  ? "actionHeaderMargin"
                                  : "headerMargin"
                                  }`}
                                style={{ textTransform: "capitalize" }}
                              >
                                {column?.headerLabel || column.render("Header")}
                              </span>
                              {column.isSortable !== false && (
                                <span>
                                  {column.isSorted ? (
                                    column.isSortedDesc ? (
                                      <FaSortDown />
                                    ) : (
                                      <FaSortUp />
                                    )
                                  ) : (
                                    <FaSort />
                                  )}
                                </span>
                              )}
                            </Flex>
                          </Th>
                        );
                      })}
                  </Tr>
                ))}
              </Thead>
              <Tbody {...getTableBodyProps()}>
                {showLoader || isLoading ? (
                  <Tr>
                    <Td colSpan={columns?.length}>
                      <Flex
                        justifyContent={"center"}
                        alignItems={"center"}
                        width="100%"
                        color={textColor}
                        fontSize="sm"
                        fontWeight="700"
                      >
                        <Spinner />
                      </Flex>
                    </Td>
                  </Tr>
                ) : data?.length === 0 ? (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <Text
                        textAlign={"center"}
                        width="100%"
                        color={textColor}
                        fontSize="sm"
                        fontWeight="500"
                      >
                        <DataNotFound />
                      </Text>
                    </Td>
                  </Tr>
                ) : (
                  page?.map((row, i) => {
                    prepareRow(row);
                    return (
                      <Tr
                        className={
                          selectedRowBg &&
                            selectedRow ===
                            (row.original?.conversationId || row.id)
                            ? "activeRow"
                            : ""
                        }
                        cursor={onRowClick ? "pointer" : "default"}
                        _hover={onRowClick ? { bg: "gray.50" } : {}}
                        onClick={() => {
                          if (title !== "Offer Letters") {
                            if (onRowClick) onRowClick(row);
                          }
                          setSelectedRow(
                            row.original?.conversationId || row.id
                          );
                        }}
                        {...row?.getRowProps()}
                      >
                        {row?.cells
                          .filter((item) =>
                            isIdHide
                              ? item.column.Header !== "#" &&
                              item.column.Header !== "Delete Id"
                              : true
                          )
                          ?.map((cell, index) => {
                            let data = "";
                            columnData?.forEach((item) => {
                              if (cell?.column.Header === item.Header) {
                                if (
                                  item.cell &&
                                  typeof item.cell === "function"
                                ) {
                                  data = (
                                    <Flex
                                      align="center"
                                      width="100%"
                                      justifyContent={
                                        (item?.center || item?.Header === "Actions" || item?.Header === "Action") ? "center" :
                                          undefined
                                      }
                                    >
                                      <Box
                                        color={textColor}
                                        fontSize="sm"
                                      >
                                        {item.cell(cell) === " "
                                          ? "-"
                                          : item.cell(cell)}
                                      </Box>
                                    </Flex>
                                  );
                                } else {
                                  data = (
                                    <Flex align="center">
                                      {item.Header === "#" && canShowCheckbox && (
                                        <Box onClick={(e) => e.stopPropagation()}>
                                          <Checkbox
                                            colorScheme="brandScheme"
                                            value={cell?.value}
                                            isChecked={selectedValues.includes(
                                              cell?.value
                                            )}
                                            isDisabled={
                                              checkBox === undefined
                                                ? false
                                                : typeof checkBox === "function"
                                                  ? !checkBox(row?.original)
                                                  : !checkBox
                                            }
                                            onChange={(event) =>
                                              handleCheckboxChange(
                                                event,
                                                cell?.value
                                              )
                                            }
                                            me="10px"
                                          />
                                        </Box>
                                      )}

                                      <Text
                                        color={textColor}
                                        fontSize="sm"
                                        onClick={
                                          disableDefaultCellNavigation
                                            ? undefined
                                            : () => handleNavigate(cell)
                                        }
                                        fontWeight="700"
                                        className={disableDefaultCellNavigation ? "" : "link-like"}
                                      >
                                        {item.Header === "#"
                                          ? cell?.row?.index + 1
                                          : cell?.value
                                            ? cell?.value
                                            : "-"}
                                      </Text>
                                    </Flex>
                                  );
                                }
                              }
                            });
                            // Check if this column should disable row click
                            const columnConfig = columnData?.find(col => col.Header === cell?.column?.Header);
                            const shouldDisableRowClick = columnConfig?.disableRowClick;

                            return (
                              <Td
                                {...cell?.getCellProps()}
                                key={index}
                                fontSize={{ sm: "14px" }}
                                minW={
                                  cell?.column?.Header === "User Name"
                                    ? {
                                      sm: "150px",
                                      md: "200px",
                                      lg: minColumnWidth || "auto",
                                    }
                                    : "auto"
                                }
                                borderColor="transparent"
                                onClick={shouldDisableRowClick ? (e) => e.stopPropagation() : undefined}
                              >
                                {data}
                              </Td>
                            );
                          })}
                      </Tr>
                    );
                  })
                )}
              </Tbody>
            </Table>
          </Box>
          {isPagination && metadata?.totalRecords > 0 && (() => {
            const pageOptions = Array.from(
              { length: metadata?.totalPages || 1 },
              (_, i) => i
            );
            return (
              <Pagination
                smallView={smallView}
                gotoPage={(pageIndex) => handlePaginationChange(pageIndex + 1)}
                gopageValue={currentPage}
                setGopageValue={setCurrentPage}
                pageCount={metadata?.totalPages || 0}
                canPreviousPage={currentPage > 1}
                previousPage={() => handlePaginationChange(currentPage - 1)}
                canNextPage={currentPage < (metadata?.totalPages || 0)}
                nextPage={() => handlePaginationChange(currentPage + 1)}
                pageOptions={pageOptions}
                setFilters={() => { }}
                setPageSize={(size) => {
                  setPageSize(size);
                  setCurrentPage(1);
                  const paginationState = {
                    pageName: title,
                    currentPage: 1,
                    pageIndex: 0,
                    pageSize: size,
                  };
                  localStorage.setItem(
                    "paginationState",
                    JSON.stringify(paginationState)
                  );
                  if (isPagination && fetchData) {
                    // Maintain filters when changing page size
                    const searchTerm = searchboxOutside || searchbox || "";
                    const statusFilter = currentStatusFilter || "";
                    const createBy = createByFilter || "";
                    const selectedUserFilter = userFilter || "";

                    // Keep server-side signature compatible: (page, limit, sort, order, search, ...)
                    if (statusFilter || createBy || searchTerm || sortColumn || selectedUserFilter || fetchData.length > 2) {
                      fetchData(
                        1,
                        size,
                        sortColumn,
                        sortOrder,
                        searchTerm,
                        false,
                        statusFilter,
                        createBy,
                        selectedUserFilter
                      );
                    } else {
                      fetchData(1, size);
                    }
                  }
                }}
                pageSize={pageSize}
                pageIndex={currentPage - 1}
                dataLength={metadata?.totalRecords || 0}
                isPagination={isPagination}
                allData={allData}
              />
            );
          })()}
        </div>

        {/* Manage Columns */}
        <Modal
          onClose={() => {
            setManageColumns(false);
          }}
          isOpen={manageColumns}
          isCentered
        >
          <ModalOverlay />
          <ModalContent maxW={"700px"}>
            <ModalHeader>{constant.manageColumns}</ModalHeader>
            <IconButton
              size="xs"
              className="closeIcon"
              onClick={() => {
                setManageColumns(false);
              }}
              icon={<CloseIcon />}
            />

            <ModalBody className="modalBody">
              <div>
                <Grid templateColumns="repeat(3, 1fr)" gap={2}>
                  {columnData
                    ?.filter(
                      (column) =>
                        !(
                          (isIdHide && column?.Header === "#") ||
                          column?.Header === "Delete Id"
                        )
                    )
                    .map((column, index) => {
                      const isAction = column?.Header === "Action";
                      return (
                        <GridItem colSpan={1} key={index}>
                          <Text
                            display={"flex"}
                            py={2}
                            opacity={isAction ? 0.5 : 1}
                          >
                            <Checkbox
                              defaultChecked={selectedColumns?.some(
                                (selectedColumn) =>
                                  selectedColumn?.accessor === column?.accessor
                              )}
                              onChange={() =>
                                toggleColumnVisibility(column?.accessor)
                              }
                              pe={2}
                              isDisabled={isAction}
                              >
                              {column?.headerLabel || column?.Header}
                            </Checkbox>
                          </Text>
                        </GridItem>
                      );
                    })}
                </Grid>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                variant="outline"
                className="theme-btn2 cancelBtn"
                colorScheme={colors.red[600]}
                size="sm"
                onClick={() => handleColumnClear()}
              >
                Close
              </Button>
              <Button
                colorScheme="brand"
                className="theme-btn1"
                ml={4}
                onClick={() => {
                  setSelectedColumns([...tempSelectedColumns]);
                  setManageColumns(false);
                }}
                disabled={isLoading ? true : false}
                size="sm"
              >
                {isLoading ? <Spinner /> : "Save"}
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Card>
    </>
  );
};

export default CommonCheckTable;
